module.exports = __webpack_public_path__ + "img/DSC02391.283e383c.jpg";